export function canEditConsultantTimesheet(sheet) {
  if (!sheet) return false;
  if (String(sheet.status || '') !== 'Time Sheet Created') return false;
  const billStatus = String(sheet.billStatus || 'Not Applicable');
  return billStatus === 'Not Applicable';
}
